const nf = (d) => new Intl.NumberFormat("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmt = (n, d = 2) => (n === null || n === undefined || Number.isNaN(n) ? "—" : nf(d).format(n));

export const fmtPct = (n) => (n === null || n === undefined ? "—" : `${n > 0 ? "+" : ""}${n.toFixed(2)}%`);

export const fmtChg = (n) => (n === null || n === undefined ? "—" : `${n > 0 ? "+" : ""}${fmt(n)}`);

export const fmtQty = (n) => {
  if (n === null || n === undefined) return "—";
  const a = Math.abs(n);
  if (a >= 1e7) return `${(n / 1e7).toFixed(2)}Cr`;
  if (a >= 1e5) return `${(n / 1e5).toFixed(2)}L`;
  if (a >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return String(n);
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("en-IN", { hour12: false, timeZone: "Asia/Kolkata" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", { hour12: false, timeZone: "Asia/Kolkata", dateStyle: "medium", timeStyle: "short" });
};

export const tone = (n) => (n > 0 ? "text-emerald-400" : n < 0 ? "text-rose-400" : "text-slate-400");

export const slug = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const fmtDuration = (secs) => {
  if (secs === null || secs === undefined) return "—";
  if (secs <= 0) return "expired";
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = Math.floor(secs % 60);
  return `${h}h ${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s`;
};
